const forms = {
  state: {
    roleAssigneeDIDCurrent: null,
    roleAssigneeDIDPrevious: null,
    rolesList: null,
    rolesListCounter: 0
  },
  mutations: {
    changeRoleAssigneeDIDCurrent(state, payload) {
      state.roleAssigneeDIDCurrent = payload;
    },
    changeRoleAssigneeDIDPrevious(state, payload) {
      state.roleAssigneeDIDPrevious = payload;
    },
    changeRolesList(state, payload) {
      state.rolesList = payload;
    },
    changeRolesListCounter(state, payload) {
      state.rolesListCounter = payload;
    }
  },
  actions: {
    changeRoleAssigneeDIDCurrent({ commit }, payload) {
      commit("changeRoleAssigneeDIDCurrent", payload);
    },
    changeRoleAssigneeDIDPrevious({ commit }, payload) {
      commit("changeRoleAssigneeDIDPrevious", payload);
    },
    changeRolesList({ commit }, payload) {
      commit("changeRolesList", payload);
    },
    changeRolesListCounter({ commit }, payload) {
      commit("changeRolesListCounter", payload);
    }
  },
  getters: {
    getRoleAssigneeDIDCurrent: state => {
      return state.roleAssigneeDIDCurrent;
    },
    getRoleAssigneeDIDPrevious: state => {
      return state.roleAssigneeDIDPrevious;
    },
    getRolesList: state => {
      return state.rolesList;
    },
    getRolesListCounter: state => {
      return state.rolesListCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
